/***
**Module Name: EditQuiz 
 **File Name :  EditQuiz.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains add user details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import tmdbApi from "../../api/tmdbApi";
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from "moment";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { contentContext } from "../../context/contentContext";
import axios from 'axios';
import DataTable from 'react-data-table-component';
import parse from "react-html-parser";
let { appname, lambda, country } = window.app;


const EditQuiz = () => {
    const history = useHistory();
    const { state } = useLocation();
    let { quizid } = useParams();
    // const { quizinfo } = state || {};
    const [quizinfo, setQuizInfo] = useState(null);
    const [files, setFiles] = useState([]);
    const [imagedisplay, setImageDisplay] = useState(false);
    const [announceWinnerPopup, setAWPopup] = useState(false);
    const [announceWinnerResult, setAWResult] = useState([]);
    const [viewResult, setViewResult] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [duplicateSuccess, setDuplicateSuccess] = useState(false);
    const [duplicateQuiz, setduplicateQuiz] = useState(false);
    const [showDelete, setShowDelete] = useState(false);

    const [success, setSuccess] = useState(false);
    const [updatesuccess, setUpdateSuccess] = useState(false);
    const [viewParticipant, setViewParticipant] = useState({});
    const [toggleClearRows, setToggleClearRows] = useState(false);
    const [imageCloudfront, setImg] = useState(false);
    const [imageDelete, setImageDelete] = useState(null);
    const [resourceBucket, setResourceImg] = useState(false);
    const [deleteSuccess, setDeleteSuccess] = useState(false);
    const [fileSizeError, setFileSizeError] = useState(false);
    const [uploadImg, setUploadImg] = useState('');
    const [submitError, setSubmitError] = useState(false);
    const[filesData,setFilesData]=useState([])
    const [inputChange, setInputChange] = useState(true);
    const [inputdateChange, setInputDateChange] = useState(false);

    const [formData, setFormData] = useState({
        name: quizinfo?.name,
        //startDate: quizinfo?.startDate?.length > 16 ? quizinfo?.startDate.slice(0, -8) : quizinfo?.startDate,
        endDate: quizinfo?.endDate?.length > 16 ? quizinfo?.endDate.slice(0, -8) : quizinfo?.endDate,
        quizType: quizinfo?.quizType,
        status: quizinfo?.status
    });
    const [errorData, setError] = useState({});
    const [errorDisplay, seterrorDisplay] = useState(false);

    const { route, setRoute, setCurrentPage, setRowsPerPage, usePrevious, setActiveMenuObj, setActiveMenuId, GetTimeActivity } = useContext(contentContext);
    const now = new Date();
    // Subtract 1 hour from the current time
    now.setMinutes(now.getMinutes() + 5);
    // Format the date and time to match the "datetime-local" input
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const currentDateTimeOneHour = `${year}-${month}-${day}T${hours}:${minutes}`;

    const columns = [

        {
            name: 'Name',
            selector: row => row?.participationDetails?.name ?? "",
            sortable: true,
        },
        {
            name: 'Score',

            cell: (props) =>
                <div className="d-flex">
                    {props?.correctAnswers}/{props?.totalQuestions}
                </div>
        },
        {
            name: 'Winner',
            cell: (props) =>

                props?.winner ? <div className="winner">
                    <span class="material-symbols-outlined icon">
                        trophy
                    </span>
                </div>: <></>

        },
        {
            name: 'Actions',
            cell: (props) =>
                <div className="d-flex">
                    <a onClick={(e) => handleViewResult(e, props)} className="btn btn-sm btn-soft-info" data-bs-toggle="modal" data-bs-target=".transaction-detailModal"><i className="mdi mdi-eye-outline mr-5"></i>View Result</a>
                </div>
        },
    ];

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                    setResourceImg(window.site.common.resourceBucket)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
            setResourceImg(window.site.common.resourceBucket)
        }


    }, [window.site]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            history.push("/admin");
        }
       
        getQuizInfoId()
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
      //  let quizinfo = JSON.parse(localStorage.getItem('eq'))
        // console.log('eddd', quizinfo)
        if (quizinfo) {
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                name: quizinfo?.name,
               // startDate: quizinfo?.startDate?.length > 16 ? quizinfo?.startDate.slice(0, -8) : quizinfo?.startDate,
                endDate: quizinfo?.endDate?.length > 16 ? quizinfo?.endDate.slice(0, -8) : quizinfo?.endDate,
                quizType: quizinfo?.quizType,
                status: quizinfo?.status
            }));
            announcResult()
        }

    }, [quizinfo]);

    const getQuizInfoId = async () => {
        try {
            const response = await tmdbApi.quizInfoId(quizid);
            // console.log(response);
            setQuizInfo(response?.result[0]);
        } catch {
            console.log("error");
        }
    };

    const handleBack = (e) => {
        // GetTimeActivity()
        history.push("/admin/dashboard");
    }

    const handleAddQuiz = (e) => {
        // GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
        //    createQuiz(formData);
           uploadFile();
        }
    }
    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;

        // console.log('form', formData)
        if (formData?.name == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["name"]: "Please enter Name", // Update the changed field
            }));
            seterrorDisplay(true)
           // setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["name"]: "", // Update the changed field
            }));
        }

        if (formData?.quizType == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["quizType"]: "Please select quiz type", // Update the changed field
            }));
            seterrorDisplay(true)
           // setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["quizType"]: "", // Update the changed field
            }));
        }

        if (formData?.status == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["status"]: "Please select status", // Update the changed field
            }));
            seterrorDisplay(true)
           // setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["status"]: "", // Update the changed field
            }));
        }

        // const formStartDate = new Date(formData?.startDate);
        // const currentDateTime = new Date(currentDateTimeOneHour);
        // if (formData?.startDate == "") {

        //     setError((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         ["startDate"]: "Please select startDate", // Update the changed field
        //     }));
        //     seterrorDisplay(true)
        //    // setTimeout(function () { seterrorDisplay(false) }, 3000);
        //     formIsValid = false;
        // } 
        // else if (inputChange && formStartDate < currentDateTime) {
        //     console.log('sss')
        //     setError((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         ["startDate"]: "Please select start time 5minutes greater than current time", // Update the changed field
        //     }));
        //     seterrorDisplay(true)
        //     // setTimeout(function () { seterrorDisplay(false) }, 3000);
        //     formIsValid = false;
        // } 
        // else {
        //     setError((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         ["startDate"]: "", // Update the changed field
        //     }));
        // }

        if (formData?.quizType == "Competitive" && formData?.endDate == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["endDate"]: "Please select endDate", // Update the changed field
            }));
            seterrorDisplay(true)
          //  setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        }
        // else if (formData?.endDate < formData?.startDate) {
        //     setError((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         ["endDate"]: "Please select enddate greater than startdate", // Update the changed field
        //     }));
        //     seterrorDisplay(true)
        //     //   setTimeout(function () { seterrorDisplay(false) }, 3000);
        //     formIsValid = false;
        // } 
        
        else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["endDate"]: "", // Update the changed field
            }));
        }

        return formIsValid;
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            [name]: value, // Update the changed field
        }));

        //if(name == "endDate"){
            setInputChange(false)
        //}
        if(name == "endDate"){
            setInputDateChange(true)
        }
        
    };

    const handleReset = (event) => {

        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            name: quizinfo.name,
            startDate: quizinfo.startDate.slice(0, -8),
            endDate: quizinfo.endDate.slice(0, -8)
        }));
    };



    // Handle row selection
    const handleRowSelected = (state) => {
        setSelectedRows(state.selectedRows);
        setSubmitError(false)
    };

    const handleDeleteFile = async () => {
        let payload = {
            source_bucket: resourceBucket,
            sourcepath: imageDelete?.filepath,
            fileid: imageDelete?.fileid
        };
        try {
            const response = await tmdbApi.deleteQuizFile(quizinfo?.quizid, payload);
            setShowDelete(false);
            setDeleteSuccess(true)
            setImageDisplay(true)
            // Save the updated formData back to localStorage with startDate and endDate intact
            const updatedFormData = {
                ...formData,
                file: "", // Ensure file is cleared but keep the other values
                fileid: "", // Similarly, clear fileid
            };

            localStorage.setItem('eq', JSON.stringify(updatedFormData));
            console.log("Updated formData", updatedFormData);

        } catch {
            console.log("error");
        }
    }
    // Handle form submission
    const handleSubmit = async (e) => {
        // console.log("Selected Rows:", selectedRows);
        // Perform your submit action (e.g., send data to an API)

        if(selectedRows && selectedRows?.length > 0) {
            let pids = []
            selectedRows.forEach(item => {
                pids.push(item?.participationid)
            });

            let participants = {
                participationids: pids
            }

            try {
                const response = await tmdbApi.winnerSubmit(participants, quizinfo?.quizid);
                //    console.log(response);
                setUpdateSuccess(true)
            } catch {
                console.log("error");
            }
        }else {
            setSubmitError(true)
        }


    };

    const handleDuplicateQuiz = async (e) => {
        setduplicateQuiz(true)
    }

    const onduplicateConfirm = (e) => {
        setDuplicateSuccess(false)
    }
    const onImageDelete = () => {
        handleDeleteFile();
    }
    const onimageDeleteCancel = (e) => {
        setShowDelete(false)
        setImageDelete(null)
    }

    const onDuplicate = async (e) => {
        try {
            const response = await tmdbApi.duplicateQuiz(quizinfo?.quizid);
            setDuplicateSuccess(true)
        } catch {
            console.log("error");
        }
        setDuplicateSuccess(true)
        setduplicateQuiz(false)

    }

    const onCancel = (e) => {
        setduplicateQuiz(false)

    }

    const handleAnnounceWinner = (e) => {
        e.preventDefault()
        setAWPopup(!announceWinnerPopup)
    };

    const handleViewResult = async (e, props) => {
        // console.log(props)
        setViewParticipant(props)
        try {
            const response = await tmdbApi.viewResult(props?.participationid);
           
            if(response?.result && response?.result.length > 0){
                setViewResult(response?.result[0]);
            }
                
        } catch {
            console.log("error");
        }
    }

    const announcResult = async () => {
        try {


            const response = await tmdbApi.announceResult(quizinfo?.quizid);
            console.log(response);
            setAWResult(response?.result);
        } catch {
            console.log("error");
        }
    };

    const createQuiz = async (files) => {
        try {
            if (files && files.length > 0) {
                formData["files"] = files
            }

            if(!inputdateChange){
                delete formData["endDate"]
            }

            const response = await tmdbApi.UpdateQuiz(formData, quizinfo?.quizid);
            console.log(response);
            // if (response?.statusCode == 200) {
            setSuccess(true);
            //  }
        } catch {
            console.log("error");
        }
    };

    const onUpdateConfirm = (e) => {
        setUpdateSuccess(false)
        setSelectedRows([])
        setToggleClearRows(!toggleClearRows);
        setAWPopup(!announceWinnerPopup)
        getQuizInfoId()
    }

    const onConfirm = () => {
        setSuccess(false);
        setInputChange(true)
        history.push("/admin/dashboard")
    };

    const handleDelete = (e, image) => {
        setShowDelete(true)
        setImageDelete(image[0])
    }
    const handleEdit = (e) => {
        setImageDisplay(true)
        setUploadImg("")
    }

    const handleRemove = () => {
        setUploadImg("")
    }

    const handleFileChange =  (event) => {
        const selectedFile = event.target.files[0];
        setInputChange(false)
        // const selectedFilesSize = selectedFile.size; //for single file
        const selectedFiles = Array.from(event.target.files);  //for multiple files
        // const selectedFilesSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);  //for multiple files
        console.log("selectedFile ", selectedFile)
        console.log("selectedFiles ", selectedFiles)

        let fileSize = 1048612 * 5 // 5MB
        if (selectedFile?.size < fileSize) {
            if (selectedFile) {
                // Create a preview URL for the image
                const previewUrl = URL.createObjectURL(selectedFile);
                setUploadImg(previewUrl); // Store the URL in state
                setImageDisplay(true)
            }
            setFilesData(selectedFiles)
        }else {
            setFileSizeError(true)
        }
       
    };

    const uploadFile = async (event) => {
       
        if(filesData && filesData?.length > 0){
            const uploadPromises = Array.from(filesData).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('userId');
                const token = localStorage.getItem('token');
                const ObjectID = require("bson-objectid");

                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;
                let fileSize = 1048612 * 5 // 5MB

                // console.log(fileSize, file?.size)
                // Check the file type
                if (file.type.startsWith('image/') && file?.size < fileSize) {

                    //var image = document.getElementById('activimg');
                    const previewUrl = URL.createObjectURL(file);
                    setUploadImg(previewUrl);
                    setImageDisplay(true)
                    let filenameReplace = file.name.replace(/ /g, "_")
                    // File is an image
                    uploadFilePath = `${appname}/${quizid}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                    bucket = window.site.common.resourceBucket; // Use resource bucket for images
                    const data = {
                        source_bucket: bucket, // Use the correct bucket based on file type
                        sourcepath: uploadFilePath
                    };
                    const newFile = [{
                        filename: filenameReplace.split('.')[0],
                        filepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    }]

                    const updatedFiles = [...files, ...newFile];
                    setFiles(updatedFiles);
                    createQuiz(updatedFiles)

                    const uploadPromise = axios.post(
                        `${lambda}/uploadFiles?appname=${appname}`,
                        data,
                        { headers: { 'Content-Type': 'application/json' } }
                    ).then(async uploadUrlResponse => {
                        if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                            const uploadUrl = uploadUrlResponse.data.result;

                            return axios.put(uploadUrl, file, {
                                headers: {
                                    'Content-Type': file.type,
                                    'Cache-Control': 'no-cache'
                                }
                            }).then(async uploadResponse => {
                                if (uploadResponse.status === 200) {
                                    // setFiles([...files, ...newFile]); 
                                } else {
                                    throw new Error('Failed to upload file to S3');
                                }
                            });
                        } else {
                            throw new Error('Failed to get upload URL');
                        }
                    });


                } else {
                    setFileSizeError(true)
                }


            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);

            } catch (error) {
                console.error('Error during file upload:', error);
            }
        }else {
            createQuiz(formData);
        }

    };

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No content found</p>
                </div> </div>
        )
    }

    // console.log('quizinfoquizinfo', quizinfo, viewResult)
    return (
        <>

            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                <div className="quiz-page main-content user-management create-user">

                    <div className="page-content ">
                        <div className="container-fluid">



                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">

                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">Edit Quiz</h4>
                                            <p className="menu-path"><span>Quiz </span> / <b>Edit Quiz</b> / <b>{quizinfo?.name || formData?.name}</b></p>

                                        </div>
                                        <div>
                                            <a onClick={handleBack} className="btn btn-primary">back</a>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {!announceWinnerPopup &&
                                <div className="create-user-block">
                                    <div className="form-block">
                                        {/* <button className="btn btn-primary btn-block btn3 ml-10" onClick={e => handleDuplicateQuiz(e)}>Duplicate Quiz</button> */}

                                        <div className="row">
                                            <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="mb-3 input-field">
                                                        <label className="form-label form-label">QUIZ NAME</label>
                                                        <input id="name" name="name" placeholder="Enter Your Name" type="text" className="form-control form-control" aria-invalid="false" onChange={handleChange} value={formData?.name} />

                                                        {errorDisplay && <span className="errormsg" style={{
                                                            fontWeight: 'bold',
                                                            color: 'red',
                                                        }}>{errorData?.name}</span>}

                                                    </div>

                                                </div>

                                                <div className="col-md-6">
                                                    <div className="mb-3 input-field">
                                                        <label className="form-label form-label">QUIZ TYPE</label>
                                                        <select name="quizType" onChange={handleChange} value={formData?.quizType} className="form-control" disabled={quizinfo?.participants > 0 ? true : false}>
                                                            <option value="">Select Type</option>
                                                            <option value="Self Assessment">Self Assessment</option>
                                                            <option value="Competitive">Competitive</option>
                                                        </select>


                                                        {errorDisplay && <span className="errormsg" style={{
                                                            fontWeight: 'bold',
                                                            color: 'red',
                                                        }}>{errorData?.quizType}</span>}
                                                    </div>
                                                </div>

                                               
                                                {formData?.quizType == "Competitive" &&
                                                <div className="col-md-6">
                                                    <div className="mb-3 input-field">
                                                        <label className="form-label form-label">END DATE</label>
                                                        <input type="datetime-local" name="endDate" className="form-control form-control" aria-invalid="false" onChange={handleChange} min={new Date().toISOString().slice(0, new Date().toISOString().lastIndexOf(":"))} value={formData?.endDate} />

                                                        {errorDisplay && <span className="errormsg" style={{
                                                            fontWeight: 'bold',
                                                            color: 'red',
                                                        }}>{errorData?.endDate}</span>}
                                                    </div>
                                                </div>}


                                                {/* <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="mb-3 input-field">
                                                            <label className="form-label form-label">START DATE</label>
                                                            <input type="datetime-local" name="startDate" className="form-control form-control" aria-invalid="false" onChange={handleChange} min={new Date().toISOString().slice(0, new Date().toISOString().lastIndexOf(":"))} value={formData?.startDate} />

                                                            {errorDisplay && <span className="errormsg" style={{
                                                                fontWeight: 'bold',
                                                                color: 'red',
                                                            }}>{errorData?.startDate}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3 input-field">
                                                            <label className="form-label form-label">END DATE</label>
                                                            <input type="datetime-local" name="endDate" className="form-control form-control" aria-invalid="false" onChange={handleChange} min={new Date().toISOString().slice(0, new Date().toISOString().lastIndexOf(":"))} value={formData?.endDate} />

                                                            {errorDisplay && <span className="errormsg" style={{
                                                                fontWeight: 'bold',
                                                                color: 'red',
                                                            }}>{errorData?.endDate}</span>}
                                                        </div>
                                                    </div>
                                                </div> */}

                                                <div className="col-md-6">
                                                    <div className="mb-3 input-field">
                                                        <label className="form-label form-label">STATUS</label>
                                                        <select name="status" onChange={handleChange} value={formData?.status} className="form-control">
                                                            <option value="">Select Status</option>
                                                            <option value="ACTIVE">ACTIVE</option>
                                                            <option value="INACTIVE">INACTIVE</option>
                                                        </select>


                                                        {errorDisplay && <span className="errormsg" style={{
                                                            fontWeight: 'bold',
                                                            color: 'red',
                                                        }}>{errorData?.status}</span>}
                                                    </div>
                                                </div>
                                                

                                                <div className="col-md-7">
                                                    <div className="mb-3 input-field">
                                                        <label className="form-label form-label">UPLOAD IMAGE</label>
                                                        <div className="upload-zone">
                                                            {imagedisplay && uploadImg !="" && <div className="upload-icon ">
                                                                <div className="img_block add_img_block">
                                                                    <span className="material-icons-outlined thumbnail-cls-icon" onClick={handleRemove}>close</span>
                                                                    <img id="activimg" src={uploadImg} width={150} />
                                                                </div>
                                                            </div>}
                                                            {!imagedisplay && quizinfo?.files && quizinfo?.files.length > 0 ? <div className="upload-icon">

                                                                <div className="img_block">
                                                                    {quizinfo?.files[0]?.filename == "Quiz-default-img" ? <span className="material-icons-outlined thumbnail-cls-icon" onClick={(e) => handleEdit(e)}>
                                                                    <i className="mdi mdi-pencil font-size-18"></i>
                                                                    </span>
                                                                    : <span className="material-icons-outlined thumbnail-cls-icon" onClick={(e) => handleDelete(e, quizinfo?.files)}>
                                                                       close
                                                                    </span>}

                                                                    {!imagedisplay && quizinfo?.files && quizinfo?.files.length > 0 &&
                                                                        <img src={`${imageCloudfront}${quizinfo?.files[0]?.filepath.replace(/ /g, "%20")}?auto=compress,format&width=150`} width="150" />}

                                                                </div>
                                                            </div> : uploadImg == "" &&
                                                                <>

                                                                    <div className="file_upload">
                                                                        <span className="material-symbols-outlined icon"> upload_file </span>
                                                                        <input
                                                                            type="file"
                                                                            id="file-upload"
                                                                            accept="image/jpeg, image/png"
                                                                            className="file-input"
                                                                            multiple={false}
                                                                            onChange={handleFileChange}
                                                                            style={{ display: 'none' }}
                                                                        />

                                                                        <label
                                                                            htmlFor="file-upload"
                                                                            className="stroke-btn btn btn-primary rounded-pill px-3 py-2 mb-2 mb-lg-0 mt-3"
                                                                        >
                                                                            Select file
                                                                        </label>
                                                                    </div>
                                                                    <div className="file_requirements ">
                                                                        <p>Maximum file size: 5MB</p>
                                                                        <p>Supported formats: JPG, PNG</p>
                                                                    </div></>}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <button className="btn btn-primary btn-block btn1 " type="submit" onClick={e => handleAddQuiz(e)} disabled={inputChange}>Update </button>
                                             {/* <button className="btn btn-primary btn-block btn2 " onClick={e => handleReset(e)}>Reset</button>  */}

                                            &nbsp;                         
                                            {quizinfo?.quizType == "Competitive" && quizinfo?.participants > 0 ?
                                                <button className="btn btn-primary btn-block btn3 mr-10" onClick={e => handleAnnounceWinner(e)}>Announce Winner</button> : quizinfo?.participants > 0 && <button className="btn btn-primary btn-block btn3 mr-10" onClick={e => handleAnnounceWinner(e)}>Participants</button> }


                                        </div>
                                    </div>
                                    <SweetAlert show={success}
                                        custom
                                        confirmBtnText="ok"
                                        confirmBtnBsStyle="primary"
                                        title={"Quiz updated successfully"}
                                        onConfirm={e => onConfirm()}
                                    >
                                    </SweetAlert>
                                </div>}

                            {announceWinnerPopup &&
                                <div className="create-user-block">
                                    <h5>{quizinfo?.quizType == "Competitive" ? "Announce Winner" : "Participants"}</h5>
                                    <div className="admin_winner_block">

                                        <DataTable 
                                            className={quizinfo?.quizType == "Competitive" ? "announedwinner_table" : "participants_table"}
                                            // title=""
                                            columns={columns}
                                            // className="table align-middle table-nowrap table-check"
                                            // keyField='_id'
                                            data={announceWinnerResult}
                                            direction="auto"
                                            highlightOnHover
                                            fixedHeaderScrollHeight="300px"
                                            pagination
                                            responsive
                                            persistTableHead
                                            // selectableRowsVisibleOnly
                                            striped
                                            selectableRowsHighlight
                                            selectableRows={quizinfo?.quizType == "Competitive" ? true : false}
                                            onSelectedRowsChange={handleRowSelected}
                                            subHeaderAlign="right"
                                            defaultSortField="name"
                                            subHeaderWra
                                            paginationTotalRows={announceWinnerResult?.length}
                                            noDataComponent={customNoRecords()}
                                            paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}


                                            paginationComponentOptions={{
                                                rowsPerPageText: 'Per page:',
                                                rangeSeparatorText: 'of',
                                                noRowsPerPage: false,
                                                selectAllRowsItem: false,
                                                selectAllRowsItemText: 'All',
                                            }}
                                            clearSelectedRows={toggleClearRows}
                                        />
                                        <div className="row">
                                            <div className="col-md-12">
                                            {submitError && <span className="errormsg" style={{
                                                            fontWeight: 'bold',
                                                            color: 'red',
                                                        }}>Please select winner</span>}<br/>

                                                {quizinfo?.quizType == "Competitive" && announceWinnerResult?.length > 0 && <button onClick={(e) => handleSubmit(e)} className="btn btn-primary btn-block btn1 " type="submit">Submit</button> }

                                                {quizinfo?.quizType == "Competitive" && announceWinnerResult?.length > 0 && <button onClick={(e) => setAWPopup(!announceWinnerPopup)} className="btn btn-primary btn-block btn2 ">Cancel</button>}

                                            </div>
                                        </div>


                                        <div className="modal result-popup fade  transaction-detailModal" tabindex="-1" role="dialog"
                                            aria-labelledby="transaction-detailModalLabel" aria-hidden="true">
                                            <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                                                <div className="modal-content">
                                                    <div class="modal-header">
                                                        <h5 class="modal-title">{viewParticipant?.participationDetails?.name} - Result</h5>
                                                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                    </div>
                                                    <div className="modal-body">
                                                        <div className="table-responsive">
                                                            <table className="table db_table">

                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th>TITLE</th>
                                                                        <th>QUESTION</th>
                                                                        <th>USER ANSWER</th>
                                                                        <th>ACTUAL ANSWER</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {viewResult && viewResult?.quiz?.length > 0 && viewResult?.quiz.map((item, index) => (
                                                                        <tr>
                                                                            <td>{item?.question}</td>
                                                                            <td>{parse(item?.description)}</td>
                                                                            <td>
                                                                                <span className={item?.actualanswer == item?.answer ? "correct text-success" : "wrong text-danger"}>{item?.answer}</span>

                                                                            </td>
                                                                            <td>{item?.actualanswer}</td>


                                                                        </tr>
                                                                    ))}

                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <SweetAlert show={updatesuccess}
                                        custom
                                        confirmBtnText="ok"
                                        confirmBtnBsStyle="primary"
                                        title={"Winner updated successfully"}
                                        onConfirm={e => onUpdateConfirm(e)}
                                    >
                                    </SweetAlert>

                                </div>
                            }

                            <SweetAlert show={duplicateQuiz}
                                warning
                                showCancel
                                confirmBtnText="Yes"
                                cancelBtnText="Cancel"
                                confirmBtnBsStyle="danger"
                                cancelBtnBsStyle="default"
                                title="Are you sure to duplicate the Quiz?"
                                focusCancelBtn
                                onConfirm={e => onDuplicate()}
                                onCancel={e => onCancel()}
                            >
                            </SweetAlert>
                            <SweetAlert show={showDelete}
                                warning
                                showCancel
                                confirmBtnText="Yes"
                                cancelBtnText="Cancel"
                                confirmBtnBsStyle="danger"
                                cancelBtnBsStyle="default"
                                title="Are you sure to delete the image?"
                                focusCancelBtn
                                onConfirm={e => onImageDelete()}
                                onCancel={e => onimageDeleteCancel()}
                            >
                            </SweetAlert>
                            <SweetAlert show={deleteSuccess}
                                custom
                                confirmBtnText="ok"
                                confirmBtnBsStyle="primary"
                                title={"Image Deleted Successfully"}
                                onConfirm={e => setDeleteSuccess(false)}
                            >
                            </SweetAlert>

                            <SweetAlert show={duplicateSuccess}
                                custom
                                confirmBtnText="ok"
                                confirmBtnBsStyle="primary"
                                title={"Duplicate Created Successfully"}
                                onConfirm={e => onduplicateConfirm()}
                            >
                            </SweetAlert>

                            <SweetAlert show={fileSizeError}
                                warning
                                confirmBtnText="ok"
                                confirmBtnBsStyle="danger"
                                title={"File size greater than 5MB"}
                                onConfirm={e => setFileSizeError(false)}
                            >
                            </SweetAlert>


                        </div>
                    </div>



                    <Footer />
                </div>


            </div>

        </>
    );
};

export default EditQuiz;
